import React, { useEffect, useState } from 'react';
import './App.css';
import { PlaybackBar } from './components/PlaybackBar/PlaybackBar';
import { PLAYBACK_BAR_HEIGHT, MOBILE_PLAYBACK_BAR_HEIGHT } from './constants';
import { pixelsToVh } from './helpers/PixelsToViewport';
import Feed from "./pages/Feed/Feed.jsx";
import Queue from "./pages/Queue/Queue.jsx";
import Focus from "./pages/Focus/Focus.jsx";
import NotFound from "./pages/NotFound/NotFound.jsx";
import Upload from "./pages/Upload/Upload.jsx";
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();
  const [isViewingFeed, setIsViewingFeed] = useState(true);
  const [isViewingQueue, setIsViewingQueue] = useState(false);
  const [isViewingUpload, setIsViewingUpload] = useState(false);
  const [isViewing404, setIsViewing404] = useState(false);
  const [focusedClip, setFocusedClip] = useState(null);

  const navigate = useNavigate();

  const displayFeed = () => {
    setIsViewingFeed(true);
    setIsViewingQueue(false);
    setIsViewingUpload(false);
    setIsViewing404(false);
    setFocusedClip(null);
  }

  const displayQueue = () => {
    setIsViewingFeed(false);
    setIsViewingQueue(true);
    setIsViewingUpload(false);
    setIsViewing404(false);
    setFocusedClip(null);
  }

  const displayFocus = (clipId) => {
    setIsViewingFeed(false);
    setIsViewingQueue(false);
    setIsViewingUpload(false);
    setIsViewing404(false);
    setFocusedClip(clipId);
  }

  const displayUpload = () => {
    setIsViewingFeed(false);
    setIsViewingQueue(false);
    setIsViewingUpload(true);
    setIsViewing404(false);
    setFocusedClip(null);
  }

  const display404 = () => {
    setIsViewingFeed(false);
    setIsViewingQueue(false);
    setIsViewingUpload(false);
    setIsViewing404(true);
    setFocusedClip(null);
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    let animations = document.getAnimations();
    const blobs = document.getElementsByClassName('blob');
    displayFeed();
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path === '/queue') {
      displayQueue(); // You need to implement this action in your visibility context
    } else if (path.startsWith('/focus/')) {
      displayFocus(path.split('/focus/')[1]); // Adjust to pass the correct clip ID to your visibility context
    } else if (path === '/upload') {
      displayUpload();
    } else if (path.split('?')[0] === '/feed') {
      displayFeed();
    } else if (path === '/404') {
      display404();
    } else if (path === '/') {
      navigate('/feed');
    } else {
      navigate('/404');
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <div className="gradient-bg">
        <div className='gradients-container'>
          <div className='blob g1' />
          <div className='blob g2' />
          <div className='blob g3' />
          <div className='blob g4' />
          <div className='blob g5' />
        </div>
      </div>
      <div className="outletContainer" style={{ paddingBottom: `${windowWidth > 768 ? PLAYBACK_BAR_HEIGHT : MOBILE_PLAYBACK_BAR_HEIGHT}px` }}>
        <Routes>
          <Route path="/queue" element={<Queue />} />
          <Route path="/focus/:clipId" element={<Focus />} />
          <Route path="/upload" element={<Upload />} />
          <Route path='/404' element={<NotFound />} />
        </Routes>
        <div style={{ display: isViewingFeed ? 'block' : 'none' }}>
          <Feed />
        </div>
      </div>
      <PlaybackBar height={`${pixelsToVh(windowWidth > 768 ? PLAYBACK_BAR_HEIGHT : MOBILE_PLAYBACK_BAR_HEIGHT)}dvh`} />
    </div>
  );
}

export default App;